import { Component, DestroyRef, OnInit, StaticProvider } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { appInject } from 'src/app/app-injector';
import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';
import { ModalService } from 'src/app/shared/modal/modal-service/modal.service';
import { Data } from 'src/app/utils/models/data.interface';

import { LazyHostComponent } from '../../../core/lazy-host/lazy-host.component';

import { modalDataRef } from './modal-data.token';

// TODO: Fix with MBCC-2652
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'cc-modal-host',
  // TODO: check if the modal host can use OnPush change detection strategy (test if updates from within hosted components still work)
  templateUrl: './modal-host.component.html',
  imports: [LazyHostComponent]
})
export class ModalHostComponent implements OnInit {
  public componentId?: LazyComponentId | null;
  public modalData?: Data | null;

  public constructor(private readonly modalService: ModalService) {}

  public get providers(): StaticProvider[] {
    return [
      {
        provide: modalDataRef,
        useValue: this.modalData || {}
      }
    ];
  }

  public ngOnInit(): void {
    this.modalService.lazyComponent$
      .pipe(takeUntilDestroyed(appInject(DestroyRef)))
      .subscribe(([componentId, data]) => {
        this.componentId = componentId;
        this.modalData = data;
      });
  }
}
